module.exports = __webpack_public_path__ + "9781c4cba9914bc23eb88dceaa4bb26f.mp4";